import React from 'react';
import type { SupportPanelTab, UnifiedPanelBadges } from '../hooks/useUnifiedPanelBadges';

const TAB_LABEL: Record<SupportPanelTab, string> = {
  demandas: 'Carteira de Trabalho',
  sop: 'Guia SOP',
  historico: 'Histórico',
};

interface UnifiedSupportPanelProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  activeTab: SupportPanelTab;
  onTabChange: (tab: SupportPanelTab) => void;
  badges: UnifiedPanelBadges;
  demandasContent: React.ReactNode;
  sopContent: React.ReactNode;
  historicoContent: React.ReactNode;
  sopDisabled?: boolean;
  historicoDisabled?: boolean;
  demandasCount?: number;
  hidden?: boolean;
  heading?: string;
  fill?: boolean;
}

export const UnifiedSupportPanel: React.FC<UnifiedSupportPanelProps> = ({
  open,
  activeTab,
  demandasContent,
  sopContent,
  historicoContent,
  demandasCount,
  hidden = false,
  heading,
  fill = false,
}) => {
  if (hidden || !open) return null;

  const contentMap: Record<SupportPanelTab, React.ReactNode> = {
    demandas: demandasContent,
    sop: sopContent,
    historico: historicoContent,
  };

  return (
    <aside className="relative flex w-[320px] min-w-[300px] max-w-[340px] shrink-0 flex-col overflow-hidden border-r border-slate-200/80 bg-white dark:border-[var(--border-default)] dark:bg-[var(--bg-elevated)]">
      <header className="flex shrink-0 items-center gap-1.5 border-b border-slate-100/80 px-3 py-1.5 dark:border-[var(--border-default)]">
        <span className="truncate text-[9px] font-bold uppercase tracking-[0.12em] text-slate-600 dark:text-slate-300">
          {heading ?? TAB_LABEL[activeTab]}
        </span>
        {!heading && activeTab === 'demandas' && demandasCount != null && (
          <span className="font-mono text-[9px] font-bold tabular-nums text-slate-500">{demandasCount}</span>
        )}
      </header>
      <div className={fill ? 'flex min-h-0 flex-1 flex-col overflow-hidden' : 'min-h-0 flex-1 overflow-y-auto'}>
        {contentMap[activeTab]}
      </div>
    </aside>
  );
};

export default UnifiedSupportPanel;
